export type PrometheusPostgreSqlDeleteStatsBackendApiProps = {
    created: number;
    pg_stat_database_tup_deleted: number;
};

export default class PrometheusPostgreSqlDeleteStats {
    readonly created: number;
    readonly pgStatDatabaseTupDeleted: number;

    constructor(props: PrometheusPostgreSqlDeleteStatsBackendApiProps) {
        this.created = props.created;
        this.pgStatDatabaseTupDeleted = props.pg_stat_database_tup_deleted;
    }
}
